import type { App } from 'vue';
import { setHtmlPageLang } from './helper';
import { createI18nWithTolgee } from 'vite-plugin-tolgee-i18n';

export const setupI18n = async (app: App<Element>) => {
    const { getCurrentLocale } = useStore('locale');
    const lang = getCurrentLocale.value;

    const defaultLocal = await import(`../../locales/${lang}.ts`);
    const messages = defaultLocal.default ?? {};
    setHtmlPageLang(lang);

    const isDevMode = import.meta.env.VITE_MODE !== 'prod';
    const i18n = await createI18nWithTolgee(app, {
        apiUrl: import.meta.env.VITE_APP_TOLGEE_API_URL || '',
        apiKey: import.meta.env.VITE_TOGGLE_SECRET || '',
        locale: lang,
        messages,
        enableRuntimeMerge: isDevMode,
    });

    return i18n;
};
